<template>
  <div>
    <div class="form-group col-md-4 row">
      <label class="padding-bottom-10">Filter by First, Last Name or Email</label>
      <input type="text" v-model="search" class="form-control">
    </div>
    <label>{{ statusMessage }}</label>
    <table class="table">
      <thead>
      <tr>
        <th
            v-for="column in columns"
        >
          {{ column.label }}
        </th>
        <th>Actions</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="detail in filteredDetails">
        <td>{{ detail.report_event_id }}</td>
        <td>{{ reportUsers[detail.user_id]['email']}}</td>
        <td>{{ reportUsers[detail.user_id]['first_name'] + ' ' + reportUsers[detail.user_id]['last_name']}}</td>
        <td>{{ detail.file_name }}</td>
        <td>{{ detail.notification_sent === 0 ? 'No' : 'Yes' }}</td>
        <td>{{ detail.created_at }}</td>
        <td>
          <a class="btn btn-xs btn-default" :href="`detail/${ detail.file_name }`" target="_blank">View Report</a>
          <a class="btn btn-xs btn-default" v-if="detail.notification_sent" @click="sendEmail($event,detail)" >{{ sendBtnName(detail) }}</a>
        </td>
      </tr>
      </tbody>
    </table>
    <confirm-modal :show-confirm="showConfirm" confirm-message="Do you want to email this report?" @ok="confirmReport" @cancel="cancelReport"></confirm-modal>
  </div>
</template>

<script>
import axios from "axios";
import ConfirmModal from "../ConfirmModal";

export default {
  name: "ReportDetail",
  components: {ConfirmModal},
  props: {
    details: {
      type: Array,
      default: []
    },
    users: {
      type: Object,
      default: []
    }
  },
  data() {
    return {
      reportDetails: this.details,
      reportUsers: this.users,
      showConfirm: false,
      statusMessage: '',
      showStatusMessage: false,
      formData: {
        reportId: 0,
        userId: 0,
      },
      search: '',
      columns: {
        id: {
          label: 'Report ID',
        },
        email: {
          label: 'User Email',
        },
        full_name: {
          label: 'Full Name',
        },
        file_name: {
          label: 'File Name',
        },
        notification_sent: {
          label: 'Notified',
        },
        created_at: {
          label: 'Created',
        },
      }
    }
  },
  computed: {
    //return this.searchQuery.toLowerCase().split(' ').every(v => item.title.toLowerCase().includes(v))
    filteredDetails() {
      let users = this.reportUsers
      const filtered = this.reportDetails.filter(item => {
        if (this.search === '') {
          return true;
        }

        const re = new RegExp(this.search, "i");

        return re.test(users[item.user_id]['first_name'])
            || re.test(users[item.user_id]['last_name'])
            || re.test(users[item.user_id]['email'])
            || re.test(users[item.user_id]['first_name'] + ' ' + users[item.user_id]['last_name']);
      })
      return filtered
    }
  },
  methods: {
    sendEmail(event,detail) {
      event.preventDefault()
      this.showConfirm = true
      this.formData.reportId = detail.report_event_id
      this.formData.userId = detail.user_id
      this.timer()
    },
    sendReport() {
      axios.post('sendOne', this.formData)
          .then(response => {
            this.statusMessage = response.data.statusMessage
            //this.reports = response.data.reportEvents
            this.timer()
            return Promise.resolve()
          })
    },
    sendBtnName(detail) {
      if(detail.notification_sent === 0) {
        return 'Send This Report'
      }
      return 'ReSend This Report'
    },
    confirmReport: function () {
      this.showConfirm = false
      this.statusMessage = "This report is being emailed."
      this.showStatusMessage = true
      this.sendReport()
      this.timer()
    },
    cancelReport: function () {
      this.showConfirm = false
      this.statusMessage = "Emailing of this report has been cancelled."
      this.showStatusMessage = true
      this.timer()
    },
    timer() {
      setTimeout(() => {
        this.showStatusMessage = false
        this.statusMessage = ''
      }, 5000)
    },
  }
}
</script>